// File: src/pages/targets/ProfitWiseReport.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Row,
  Col,
  Input,
  Button,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  Alert,
  Label,
} from "reactstrap";
import { ImDownload } from "react-icons/im";
import {
  FaChartLine,
  FaColumns,
  FaCompressAlt,
  FaExpandAlt,
  FaEye,
  FaEyeSlash,
  FaFileExcel,
  FaFilePdf,
  FaFilter,
  FaLayerGroup,
  FaMagic,
  FaPalette,
  FaSearch,
  FaSlidersH,
  FaSort,
  FaSortDown,
  FaSortUp,
  FaSyncAlt,
  FaTimes,
} from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import SuperAdminUI from "../import/SuperAdminUI";
import { CheckPermission } from "../import/CheckPermission";
import { exportDataToPDF } from "../import/Downloader";

import { _Get, createOrderhistoryview } from "../import/ApiEndPoint/ApiCalling";
import { PurchaseProductList_Product } from "../import/ApiEndPoint/Api";

/* ---------------- CSS ---------------- */

const injectOnce = () => {
  const css = `
    .pwr-page{
      width:100%;
      min-height:100vh;
      background:
        radial-gradient(circle at 0% 0%, rgba(37,99,235,.13), transparent 26%),
        radial-gradient(circle at 100% 0%, rgba(16,185,129,.14), transparent 28%),
        linear-gradient(180deg,#f8fafc 0%,#eef3f8 100%);
      padding:8px;
      color:#0f172a;
    }

    .pwr-top-shell{
      border:1px solid rgba(148,163,184,.28);
      background:rgba(255,255,255,.86);
      backdrop-filter:blur(16px);
      border-radius:18px;
      box-shadow:0 14px 38px rgba(15,23,42,.09);
      overflow:hidden;
      margin-bottom:8px;
    }

    .pwr-command-row{
      display:flex;
      align-items:center;
      gap:7px;
      overflow-x:auto;
      overflow-y:hidden;
      white-space:nowrap;
      padding:8px;
      scrollbar-width:thin;
    }

    .pwr-command-row::-webkit-scrollbar{height:6px}
    .pwr-command-row::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:20px}

    .pwr-brand{
      height:36px;
      display:inline-flex;
      align-items:center;
      gap:8px;
      padding:0 13px;
      border-radius:13px;
      background:linear-gradient(135deg,#0f172a,#1d4ed8);
      color:#fff;
      font-weight:950;
      font-size:13px;
      letter-spacing:.02em;
      flex:0 0 auto;
      box-shadow:0 8px 18px rgba(37,99,235,.22);
    }

    .pwr-count{
      min-width:26px;
      height:22px;
      padding:0 7px;
      display:inline-flex;
      align-items:center;
      justify-content:center;
      background:rgba(255,255,255,.18);
      border:1px solid rgba(255,255,255,.24);
      border-radius:999px;
      font-size:11px;
      font-weight:950;
    }

    .pwr-smart-card{
      height:36px;
      display:inline-flex;
      align-items:center;
      gap:6px;
      padding:0 10px;
      border-radius:13px;
      background:#fff;
      border:1px solid #e2e8f0;
      font-size:12px;
      font-weight:900;
      flex:0 0 auto;
      box-shadow:0 4px 12px rgba(15,23,42,.04);
    }

    .pwr-smart-card b{
      color:#64748b;
      font-size:10.5px;
      text-transform:uppercase;
      letter-spacing:.05em;
    }

    .pwr-smart-card span{
      font-variant-numeric:tabular-nums;
      color:#0f172a;
    }

    .pwr-pos{color:#047857 !important}
    .pwr-neg{color:#b91c1c !important}

    .pwr-searchbox{
      height:36px;
      min-width:230px;
      display:inline-flex;
      align-items:center;
      gap:6px;
      padding:0 8px;
      border-radius:13px;
      background:#fff;
      border:1px solid #dbe3ef;
      flex:0 0 auto;
    }

    .pwr-searchbox svg{color:#64748b;flex:0 0 auto}

    .pwr-searchbox input{
      border:0 !important;
      outline:0 !important;
      box-shadow:none !important;
      padding:0 !important;
      height:28px !important;
      min-height:28px !important;
      font-size:12.5px !important;
      font-weight:800 !important;
      background:transparent !important;
      color:#0f172a !important;
      min-width:180px;
    }

    .pwr-field{
      height:36px;
      display:inline-flex;
      align-items:center;
      gap:5px;
      padding:0 7px;
      border-radius:13px;
      background:#fff;
      border:1px solid #dbe3ef;
      flex:0 0 auto;
    }

    .pwr-field label{
      margin:0;
      color:#475569;
      font-size:10.5px;
      font-weight:950;
      letter-spacing:.05em;
      text-transform:uppercase;
    }

    .pwr-field .form-control,
    .pwr-field select,
    .pwr-field input{
      height:27px !important;
      min-height:27px !important;
      border-radius:9px !important;
      border:1px solid #e2e8f0 !important;
      box-shadow:none !important;
      padding:2px 7px !important;
      font-size:12px !important;
      font-weight:850 !important;
      background:#fff !important;
      color:#0f172a !important;
    }

    .pwr-select-fy{width:92px !important}
    .pwr-select-type{width:108px !important}
    .pwr-select-period{width:112px !important}
    .pwr-select-band{width:112px !important}
    .pwr-select-limit{width:112px !important}

    .pwr-icon-btn{
      height:36px !important;
      min-width:36px !important;
      padding:0 10px !important;
      border-radius:13px !important;
      display:inline-flex !important;
      align-items:center !important;
      justify-content:center !important;
      gap:6px !important;
      font-weight:900 !important;
      font-size:12px !important;
      flex:0 0 auto;
      box-shadow:none !important;
    }

    .pwr-primary-btn{
      background:#2563eb !important;
      border-color:#2563eb !important;
      color:#fff !important;
    }

    .pwr-download-wrap{
      position:relative;
      display:inline-flex;
      flex:0 0 auto;
    }

    .pwr-download-trigger{
      height:36px;
      min-width:38px;
      border-radius:13px;
      display:flex;
      align-items:center;
      justify-content:center;
      cursor:pointer;
      background:#0f172a;
      border:1px solid #0f172a;
      color:#fff;
    }

    .pwr-download-menu{
      position:absolute;
      right:0;
      top:40px;
      z-index:80;
      width:155px;
      border:1px solid #e5e7eb;
      background:#fff;
      border-radius:14px;
      overflow:hidden;
      box-shadow:0 20px 45px rgba(15,23,42,.18);
      padding:5px;
    }

    .pwr-dl-item{
      padding:9px 10px;
      cursor:pointer;
      font-weight:850;
      border-radius:10px;
      display:flex;
      align-items:center;
      gap:8px;
      color:#0f172a;
      font-size:13px;
    }

    .pwr-dl-item:hover{background:#eff6ff;color:#1d4ed8}

    .pwr-advanced{
      border-top:1px solid #e5e7eb;
      padding:8px;
      background:linear-gradient(180deg,#fff,#f8fafc);
    }

    .pwr-chip-line{
      display:flex;
      align-items:center;
      gap:6px;
      overflow-x:auto;
      padding:0;
      scrollbar-width:thin;
    }

    .pwr-chip-line::-webkit-scrollbar{height:6px}
    .pwr-chip-line::-webkit-scrollbar-thumb{background:#cbd5e1;border-radius:20px}

    .pwr-chip{
      display:inline-flex;
      align-items:center;
      gap:5px;
      height:28px;
      padding:0 9px;
      border-radius:999px;
      border:1px solid #e2e8f0;
      background:#fff;
      color:#0f172a;
      font-size:11px;
      font-weight:950;
      cursor:pointer;
      flex:0 0 auto;
    }

    .pwr-chip.active{
      color:#fff;
      background:#2563eb;
      border-color:#2563eb;
      box-shadow:0 8px 18px rgba(37,99,235,.22);
    }

    .pwr-dot{
      width:10px;
      height:10px;
      border-radius:999px;
      border:1px solid rgba(15,23,42,.16);
      flex:0 0 auto;
    }

    .pwr-master-box{
      margin-bottom:8px;
      padding:8px;
      border-radius:14px;
      background:#fff;
      border:1px solid #e2e8f0;
      box-shadow:0 6px 18px rgba(15,23,42,.06);
    }

    .pwr-table-card{
      border:1px solid #dfe7f3;
      border-radius:16px;
      background:#fff;
      box-shadow:0 14px 32px rgba(15,23,42,.08);
      overflow:hidden;
    }

    .pwr-table-head{
      min-height:40px;
      padding:7px 10px;
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:10px;
      background:linear-gradient(90deg,#ffffff,#f8fafc);
      border-bottom:1px solid #e5e7eb;
    }

    .pwr-table-title{
      display:flex;
      align-items:center;
      gap:7px;
      font-weight:950;
      font-size:13px;
      color:#0f172a;
      text-transform:uppercase;
      letter-spacing:.03em;
    }

    .pwr-table-meta{
      color:#64748b;
      font-size:12px;
      font-weight:850;
    }

    .pwr-table-wrap{
      width:100%;
      overflow:auto;
      background:#fff;
      max-height:calc(100vh - 130px);
    }

    .pwr-table{
      width:100%;
      border-collapse:separate;
      border-spacing:0;
      table-layout:auto;
      min-width:1100px;
    }

    .pwr-table thead th{
      background:#f8fafc;
      color:#334155;
      font-weight:950;
      text-transform:uppercase;
      font-size:10.5px;
      letter-spacing:.06em;
      border-bottom:1px solid #e5e7eb;
      padding:9px 8px;
      position:sticky;
      top:0;
      z-index:3;
      text-align:center;
      white-space:nowrap;
      cursor:pointer;
      user-select:none;
    }

    .pwr-table thead th:hover{background:#eef6ff;color:#1d4ed8}

    .pwr-table tbody td{
      padding:8px 8px;
      border-bottom:1px solid #f1f5f9;
      vertical-align:middle;
      color:#0f172a;
      font-size:13px;
      text-align:center;
      font-weight:760;
      background:#fff;
    }

    .pwr-page.comfortable .pwr-table tbody td{
      padding:12px 10px;
      font-size:14px;
    }

    .pwr-table tbody tr:hover td{background:#f8fbff}

    .pwr-table tfoot td{
      padding:10px 8px;
      font-weight:950;
      background:#f8fafc;
      border-top:1px solid #e5e7eb;
      text-align:center;
      color:#0f172a;
      position:sticky;
      bottom:0;
      z-index:2;
    }

    .pwr-first-col{
      position:sticky;
      left:0;
      z-index:2;
      text-align:left !important;
      min-width:270px;
      box-shadow:8px 0 16px rgba(15,23,42,.04);
    }

    thead .pwr-first-col{
      z-index:4;
      background:#f8fafc !important;
    }

    tfoot .pwr-first-col{
      z-index:3;
      background:#f8fafc !important;
    }

    .pwr-product-cell{
      display:flex;
      align-items:center;
      gap:8px;
      min-width:0;
    }

    .pwr-product-avatar{
      width:31px;
      height:31px;
      border-radius:11px;
      display:flex;
      align-items:center;
      justify-content:center;
      background:#eff6ff;
      color:#1d4ed8;
      font-weight:950;
      flex:0 0 auto;
      border:1px solid #dbeafe;
      font-size:12px;
    }

    .pwr-product-name{
      font-weight:950;
      white-space:normal;
      line-height:1.2;
      font-size:13px;
    }

    .pwr-product-sub{
      font-size:10px;
      color:#64748b;
      font-weight:850;
      margin-top:1px;
    }

    .pwr-money{
      font-variant-numeric:tabular-nums;
      white-space:nowrap;
    }

    .pwr-band-pill{
      display:inline-flex;
      align-items:center;
      justify-content:center;
      min-width:66px;
      height:25px;
      padding:0 9px;
      border-radius:999px;
      border:1px solid rgba(15,23,42,.12);
      font-size:11px;
      font-weight:950;
      color:#0f172a;
    }

    .pwr-percent-wrap{min-width:98px}

    .pwr-percent-text{
      font-weight:950;
      margin-bottom:4px;
      font-size:12px;
    }

    .pwr-percent-bar{
      width:100%;
      height:6px;
      border-radius:999px;
      background:#e5e7eb;
      overflow:hidden;
    }

    .pwr-percent-fill{
      height:100%;
      border-radius:999px;
    }

    .pwr-card-grid{
      display:grid;
      grid-template-columns:repeat(4,minmax(190px,1fr));
      gap:8px;
      padding:8px;
    }

    .pwr-product-card{
      border:1px solid #e2e8f0;
      border-radius:16px;
      background:#fff;
      padding:10px;
      box-shadow:0 8px 18px rgba(15,23,42,.05);
    }

    .pwr-card-title{
      font-size:13px;
      font-weight:950;
      line-height:1.2;
      margin-bottom:8px;
    }

    .pwr-card-row{
      display:flex;
      justify-content:space-between;
      gap:8px;
      font-size:12px;
      font-weight:850;
      padding:4px 0;
      border-top:1px dashed #e5e7eb;
    }

    .pwr-card-row b{
      color:#64748b;
      font-weight:950;
    }

    .pwr-empty{
      padding:34px 18px;
      text-align:center;
      color:#64748b;
      background:#fff;
    }

    .pwr-empty-title{
      font-size:16px;
      font-weight:950;
      color:#0f172a;
      margin-bottom:5px;
    }

    .picklist{
      border:1px solid #e5e7eb;
      border-radius:14px;
      background:#fff;
      padding:8px;
      max-height:330px;
      overflow:auto;
    }

    .pickitem{
      padding:9px 11px;
      border:1px solid #e5e7eb;
      border-radius:10px;
      margin-bottom:6px;
      background:#fff;
      cursor:pointer;
      font-weight:800;
      display:flex;
      align-items:center;
      justify-content:space-between;
      gap:8px;
    }

    .pickitem:hover{
      background:#f8fafc;
      border-color:#bfdbfe;
    }

    .pwr-modal-title{
      font-weight:950;
      color:#0f172a;
      text-transform:uppercase;
      letter-spacing:.03em;
      margin-bottom:9px;
      display:flex;
      align-items:center;
      gap:8px;
      font-size:13px;
    }

    .pwr-modal-actions{
      display:flex;
      gap:8px;
      flex-wrap:wrap;
      align-items:center;
      justify-content:center;
      margin-top:10px;
    }

    .pwr-loader{
      min-height:70vh;
      display:flex;
      align-items:center;
      justify-content:center;
      flex-direction:column;
      gap:14px;
      color:#334155;
      font-weight:900;
    }

    .pwr-loader .spinner-border{
      width:4rem;
      height:4rem;
    }

    @media(max-width:1300px){
      .pwr-card-grid{grid-template-columns:repeat(3,minmax(190px,1fr))}
    }

    @media(max-width:767px){
      .pwr-page{padding:6px 4px}
      .pwr-command-row{padding:6px;gap:5px}
      .pwr-brand,.pwr-smart-card,.pwr-field,.pwr-searchbox,.pwr-icon-btn,.pwr-download-trigger{height:33px}
      .pwr-searchbox{min-width:180px}
      .pwr-searchbox input{min-width:130px}
      .pwr-table-wrap{max-height:none}
      .pwr-table{min-width:1000px}
      .pwr-first-col{min-width:230px}
      .pwr-card-grid{grid-template-columns:1fr}
    }
  `;

  const old = document.getElementById("profit-wise-report-inline-css");
  if (old) {
    old.innerHTML = css;
    return;
  }

  const style = document.createElement("style");
  style.id = "profit-wise-report-inline-css";
  style.innerHTML = css;
  document.head.appendChild(style);
};

/* ---------------- helpers ---------------- */

const toStr = (v) => (v === null || v === undefined ? "" : String(v));
const N = (v) => (isNaN(Number(v)) ? 0 : Number(v));
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const money = (v) => round2(v ?? 0).toFixed(2);
const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

const defaultColorConfig = {
  green: "#75fa8e",
  orange: "#d9614c",
  blue: "#87c8fa",
  red: "#f78981",
};

const getProfitColor = (profitPercentage, colorConfig) => {
  const raw = profitPercentage ?? "";
  const normalized = String(raw).replace(/[^\d.-]/g, "");
  const p = normalized === "" ? 0 : Number(normalized) || 0;

  const merged = {
    ...defaultColorConfig,
    ...(colorConfig || {}),
  };

  if (p >= 15) return merged.green;
  if (p >= 10) return merged.orange;
  if (p >= 5) return merged.blue;
  return merged.red;
};

const getProfitBand = (profitPercentage) => {
  const p = Number(profitPercentage || 0);
  if (p >= 15) return "green";
  if (p >= 10) return "orange";
  if (p >= 5) return "blue";
  return "red";
};

const getProfitBandLabel = (band) => {
  if (band === "green") return "High";
  if (band === "orange") return "Good";
  if (band === "blue") return "Low";
  if (band === "red") return "Risk";
  return "";
};

const landedCostOf = (r) =>
  Number(r?.Purchase_Rate) > Number(r?.landedCost)
    ? Number(r?.Purchase_Rate)
    : Number(r?.landedCost);

const getFYYears = (date) => {
  const d = new Date(date);
  const m = d.getMonth();
  const y = d.getFullYear();
  return m >= 3 ? { start: y, end: y + 1 } : { start: y - 1, end: y };
};

const getFinancialYearLabel = (startYear) =>
  `${startYear}-${String(startYear + 1).slice(-2)}`;

const isInFinancialPeriod = (
  dateValue,
  filterType,
  fyStartYear,
  periodValue,
) => {
  if (!dateValue) return false;

  const d = new Date(dateValue);
  if (isNaN(d.getTime())) return false;

  if (!fyStartYear) return true;

  const { start } = getFYYears(d);
  if (Number(start) !== Number(fyStartYear)) return false;

  if (!filterType || filterType === "yearly") return true;

  const month = d.getMonth();

  if (filterType === "halfYearly") {
    if (periodValue === "H1") return month >= 3 && month <= 8;
    if (periodValue === "H2") return month >= 9 || month <= 2;
    return true;
  }

  if (filterType === "quarterly") {
    if (periodValue === "Q1") return month >= 3 && month <= 5;
    if (periodValue === "Q2") return month >= 6 && month <= 8;
    if (periodValue === "Q3") return month >= 9 && month <= 11;
    if (periodValue === "Q4") return month >= 0 && month <= 2;
    return true;
  }

  if (filterType === "monthly") {
    const monthlyMap = {
      April: 3,
      May: 4,
      June: 5,
      July: 6,
      August: 7,
      September: 8,
      October: 9,
      November: 10,
      December: 11,
      January: 0,
      February: 1,
      March: 2,
    };
    return month === monthlyMap[periodValue];
  }

  return true;
};

const monthOptionsFY = [
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
];

const getInitial = (name) =>
  String(name || "P")
    .trim()
    .charAt(0)
    .toUpperCase() || "P";

const sortValue = (row, key) => {
  if (key === "product") return String(row?.productName || "").toLowerCase();
  return Number(row?.[key] || 0);
};

/* ---------------- columns ---------------- */

const BASE_COLS = [
  {
    key: "product",
    header: "Product Name",
    type: "text",
    get: (r) => r?.productName || "",
    render: (r, colorConfig) => (
      <div className="pwr-product-cell">
        <div className="pwr-product-avatar">{getInitial(r?.productName)}</div>
        <div>
          <div
            className="pwr-product-name"
            style={{ color: getProfitColor(r?.profitPercent, colorConfig) }}
          >
            {r?.productName || ""}
          </div>
          <div className="pwr-product-sub">Product wise profit</div>
        </div>
      </div>
    ),
  },
  {
    key: "saleQty",
    header: "Sale Qty",
    type: "number",
    get: (r) => round2(r?.saleQty ?? 0).toFixed(2),
    render: (r) => <span className="pwr-money">{money(r?.saleQty)}</span>,
  },
  {
    key: "avgSaleRate",
    header: "Avg Sale Rate",
    type: "number",
    get: (r) => round2(r?.avgSaleRate ?? 0).toFixed(2),
    render: (r) => <span className="pwr-money">{money(r?.avgSaleRate)}</span>,
  },
  {
    key: "avgPurchaseRate",
    header: "Avg Purchase Rate",
    type: "number",
    get: (r) => round2(r?.avgPurchaseRate ?? 0).toFixed(2),
    render: (r) => (
      <span className="pwr-money">{money(r?.avgPurchaseRate)}</span>
    ),
  },
  {
    key: "saleAmount",
    header: "Sale Amount",
    type: "number",
    get: (r) => round2(r?.saleAmount ?? 0).toFixed(2),
    render: (r) => <span className="pwr-money">{money(r?.saleAmount)}</span>,
  },
  {
    key: "purchaseAmount",
    header: "Purchase Amount",
    type: "number",
    get: (r) => round2(r?.purchaseAmount ?? 0).toFixed(2),
    render: (r) => (
      <span className="pwr-money">{money(r?.purchaseAmount)}</span>
    ),
  },
  {
    key: "profit",
    header: "Profit",
    type: "number",
    get: (r) => round2(r?.profit ?? 0).toFixed(2),
    render: (r) => (
      <span
        className={`pwr-money ${
          Number(r?.profit || 0) < 0 ? "pwr-neg" : "pwr-pos"
        }`}
        style={{ fontWeight: 950 }}
      >
        {money(r?.profit)}
      </span>
    ),
  },
  {
    key: "profitPercent",
    header: "Profit %",
    type: "number",
    get: (r) => round2(r?.profitPercent ?? 0).toFixed(2),
    render: (r, colorConfig) => {
      const bg = getProfitColor(r?.profitPercent, colorConfig);
      const width = clamp(Math.abs(Number(r?.profitPercent || 0)), 0, 100);

      return (
        <div className="pwr-percent-wrap">
          <div className="pwr-percent-text" style={{ color: bg }}>
            {round2(r?.profitPercent ?? 0).toFixed(2)}%
          </div>
          <div className="pwr-percent-bar">
            <div
              className="pwr-percent-fill"
              style={{
                width: `${width}%`,
                background: bg,
              }}
            />
          </div>
        </div>
      );
    },
  },
  {
    key: "profitBand",
    header: "Band",
    type: "text",
    get: (r) => getProfitBandLabel(r?.profitBand),
    render: (r, colorConfig) => (
      <span
        className="pwr-band-pill"
        style={{
          background: getProfitColor(r?.profitPercent, colorConfig),
        }}
      >
        {getProfitBandLabel(r?.profitBand)}
      </span>
    ),
  },
];

export default function AutoCompanyTarget() {
  const addBufferRef = useRef([]);

  const [loading, setLoading] = useState(true);
  const [downloadOpen, setDownloadOpen] = useState(false);
  const [modal, setModal] = useState(false);
  const [advancedOpen, setAdvancedOpen] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [permissions, setPermissions] = useState({
    View: true,
    Create: true,
    Edit: true,
    Delete: true,
    Download: true,
  });

  const [masterShow, setMasterShow] = useState(false);
  const [colorConfig, setColorConfig] = useState(defaultColorConfig);

  const [productMap, setProductMap] = useState(new Map());
  const [rawItems, setRawItems] = useState([]);

  const [selectedFY, setSelectedFY] = useState("");
  const [filterType, setFilterType] = useState("yearly");
  const [periodValue, setPeriodValue] = useState("");
  const [profitColorFilter, setProfitColorFilter] = useState("all");
  const [quickFilter, setQuickFilter] = useState("all");
  const [limitMode, setLimitMode] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedKeys, setSelectedKeys] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);

  const [sortConfig, setSortConfig] = useState({
    key: "profit",
    dir: "desc",
  });

  const [viewMode, setViewMode] = useState(
    localStorage.getItem("ProfitWiseReportView") || "table",
  );

  const [density, setDensity] = useState(
    localStorage.getItem("ProfitWiseReportDensity") || "compact",
  );

  useEffect(() => injectOnce(), []);

  useEffect(() => {
    localStorage.setItem("ProfitWiseReportView", viewMode);
  }, [viewMode]);

  useEffect(() => {
    localStorage.setItem("ProfitWiseReportDensity", density);
  }, [density]);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("PriceListColorConfig_v1");
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === "object") {
          setColorConfig((prev) => ({ ...prev, ...parsed }));
        }
      }
    } catch {
      // ignore
    }
  }, []);

  useEffect(() => {
    if (filterType === "yearly") {
      setPeriodValue("");
    } else if (filterType === "halfYearly") {
      setPeriodValue("H1");
    } else if (filterType === "quarterly") {
      setPeriodValue("Q1");
    } else if (filterType === "monthly") {
      setPeriodValue("April");
    }
  }, [filterType]);

  const loadData = async () => {
    setLoading(true);
    setErrorMsg("");

    try {
      const user = JSON.parse(localStorage.getItem("userData") || "{}");
      const uid = user?._id || user?.id || "";
      const db = user?.database || user?.db || "";

      if (user?.rolename?.roleName === "MASTER") setMasterShow(true);

      const inside = CheckPermission("PARTY WISE AND PRODUCT WISE SALE REPORT");
      if (inside && typeof inside === "object") {
        setPermissions((p) => ({ ...p, ...inside }));
      }

      const prodRes = await _Get(PurchaseProductList_Product, db);
      const products = Array.isArray(prodRes?.Product) ? prodRes.Product : [];
      const pMap = new Map();

      products.forEach((p) => {
        const pid = String(p?._id || p?.id || "");
        if (!pid) return;
        pMap.set(pid, {
          _id: pid,
          productName: p?.Product_Title || "",
          avgPurchaseRate: landedCostOf(p) || 0,
        });
      });

      setProductMap(pMap);

      const res = await createOrderhistoryview(uid);
      const completed = Array.isArray(res?.orderHistory)
        ? res.orderHistory.filter((o) =>
            String(o?.status || "")
              .toLowerCase()
              .includes("completed"),
          )
        : [];

      const flatItems = completed.flatMap((ord) =>
        (ord?.orderItems || []).map((it, idx) => {
          const pid =
            it?.productId?._id ||
            it?.productId?.id ||
            it?.productId ||
            it?.ProductId ||
            it?.product_id ||
            "";

          const productName =
            it?.productId?.Product_Title ||
            it?.Product_Title ||
            pMap.get(String(pid || ""))?.productName ||
            "Unknown Product";

          return {
            _rowId: `${ord?._id || ord?.invoiceId || "ord"}-${idx}`,
            productId: String(pid || ""),
            productName,
            qty: N(it?.qty),
            saleRate: N(it?.price),
            orderDate: ord?.date || ord?.updatedAt || "",
          };
        }),
      );

      setRawItems(flatItems);

      const fyStarts = flatItems
        .filter((x) => x?.orderDate)
        .map((x) => getFYYears(x.orderDate).start)
        .filter((x) => Number.isFinite(x));

      if (fyStarts.length) {
        const latestFY = Math.max(...fyStarts);
        setSelectedFY(String(latestFY));
      } else {
        setSelectedFY("");
      }

      const saved = localStorage.getItem("ProfitWiseReportCols");
      const parsed = saved ? JSON.parse(saved) : null;

      if (Array.isArray(parsed) && parsed.length) {
        const keys = parsed
          .map((c) => c?.key)
          .filter((k) => BASE_COLS.some((b) => b.key === k));
        setSelectedKeys(keys.length ? keys : BASE_COLS.map((c) => c.key));
      } else {
        setSelectedKeys(BASE_COLS.map((c) => c.key));
      }
    } catch (e) {
      console.error("[ProfitWiseReport] load error:", e);
      setErrorMsg(
        e?.response?.data?.message || e?.message || "Failed to load data.",
      );
      setRawItems([]);
      setProductMap(new Map());
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const fyOptions = useMemo(() => {
    const years = new Set();

    rawItems.forEach((it) => {
      if (!it?.orderDate) return;
      const d = new Date(it.orderDate);
      if (isNaN(d.getTime())) return;
      const { start } = getFYYears(it.orderDate);
      years.add(start);
    });

    const arr = Array.from(years).sort((a, b) => b - a);
    return arr.map((start) => ({
      value: String(start),
      label: getFinancialYearLabel(start),
    }));
  }, [rawItems]);

  const filteredItems = useMemo(() => {
    return rawItems.filter((it) =>
      isInFinancialPeriod(it?.orderDate, filterType, selectedFY, periodValue),
    );
  }, [rawItems, filterType, selectedFY, periodValue]);

  const groupedRows = useMemo(() => {
    const grouped = new Map();

    filteredItems.forEach((it) => {
      const pid = String(it?.productId || "");
      if (!pid) return;

      if (!grouped.has(pid)) {
        const pm = productMap.get(pid);
        grouped.set(pid, {
          productId: pid,
          productName: it?.productName || pm?.productName || "Unknown Product",
          saleQty: 0,
          saleRateTotal: 0,
          saleRateCount: 0,
          avgPurchaseRate: pm?.avgPurchaseRate || 0,
        });
      }

      const row = grouped.get(pid);
      row.saleQty += N(it?.qty);
      row.saleRateTotal += N(it?.saleRate);
      row.saleRateCount += 1;
    });

    const finalRows = Array.from(grouped.values()).map((r) => {
      const avgSaleRate =
        r.saleRateCount > 0 ? round2(r.saleRateTotal / r.saleRateCount) : 0;
      const avgPurchaseRate = round2(r.avgPurchaseRate || 0);
      const saleAmount = round2((r.saleQty || 0) * avgSaleRate);
      const purchaseAmount = round2((r.saleQty || 0) * avgPurchaseRate);
      const profit = round2(saleAmount - purchaseAmount);
      const profitPercent =
        purchaseAmount > 0 ? round2((profit / purchaseAmount) * 100) : 0;

      return {
        productId: r.productId,
        productName: r.productName,
        saleQty: round2(r.saleQty),
        avgSaleRate,
        avgPurchaseRate,
        saleAmount,
        purchaseAmount,
        profit,
        profitPercent,
        profitBand: getProfitBand(profitPercent),
      };
    });

    return finalRows.sort((a, b) =>
      String(a?.productName || "").localeCompare(String(b?.productName || "")),
    );
  }, [filteredItems, productMap]);

  const searchedAndFilteredRows = useMemo(() => {
    const q = String(searchTerm || "")
      .trim()
      .toLowerCase();

    return groupedRows.filter((r) => {
      const fullText = [
        r?.productName,
        r?.saleQty,
        r?.avgSaleRate,
        r?.avgPurchaseRate,
        r?.saleAmount,
        r?.purchaseAmount,
        r?.profit,
        r?.profitPercent,
        getProfitBandLabel(r?.profitBand),
      ]
        .join(" ")
        .toLowerCase();

      const searchOk =
        !q ||
        q
          .split(/\s+/)
          .filter(Boolean)
          .every((part) => fullText.includes(part));

      const bandOk =
        profitColorFilter === "all" || r?.profitBand === profitColorFilter;

      let quickOk = true;
      if (quickFilter === "profit") quickOk = Number(r?.profit || 0) > 0;
      if (quickFilter === "loss") quickOk = Number(r?.profit || 0) < 0;
      if (quickFilter === "high") quickOk = Number(r?.profitPercent || 0) >= 15;
      if (quickFilter === "risk") quickOk = Number(r?.profitPercent || 0) < 5;
      if (quickFilter === "zeroPurchase")
        quickOk = Number(r?.purchaseAmount || 0) === 0;

      return searchOk && bandOk && quickOk;
    });
  }, [groupedRows, searchTerm, profitColorFilter, quickFilter]);

  const rows = useMemo(() => {
    let arr = [...searchedAndFilteredRows];

    if (limitMode === "top10") {
      return arr.sort((a, b) => N(b?.profit) - N(a?.profit)).slice(0, 10);
    }

    if (limitMode === "bottom10") {
      return arr.sort((a, b) => N(a?.profit) - N(b?.profit)).slice(0, 10);
    }

    if (limitMode === "topMargin") {
      return arr
        .sort((a, b) => N(b?.profitPercent) - N(a?.profitPercent))
        .slice(0, 10);
    }

    if (limitMode === "topSale") {
      return arr
        .sort((a, b) => N(b?.saleAmount) - N(a?.saleAmount))
        .slice(0, 10);
    }

    const col = BASE_COLS.find((c) => c.key === sortConfig.key);
    const dir = sortConfig.dir === "asc" ? 1 : -1;

    arr.sort((a, b) => {
      const av = sortValue(a, sortConfig.key);
      const bv = sortValue(b, sortConfig.key);

      if (col?.type === "text") {
        return String(av).localeCompare(String(bv)) * dir;
      }

      return (Number(av || 0) - Number(bv || 0)) * dir;
    });

    return arr;
  }, [searchedAndFilteredRows, sortConfig, limitMode]);

  const colMap = useMemo(() => {
    const m = new Map();
    BASE_COLS.forEach((c) => m.set(c.key, c));
    return m;
  }, []);

  const visibleCols = useMemo(
    () => selectedKeys.map((k) => colMap.get(k)).filter(Boolean),
    [selectedKeys, colMap],
  );

  const totals = useMemo(() => {
    const acc = {
      saleQty: 0,
      saleAmount: 0,
      purchaseAmount: 0,
      profit: 0,
    };

    rows.forEach((r) => {
      acc.saleQty += N(r?.saleQty);
      acc.saleAmount += N(r?.saleAmount);
      acc.purchaseAmount += N(r?.purchaseAmount);
      acc.profit += N(r?.profit);
    });

    return {
      saleQty: round2(acc.saleQty),
      avgSaleRate: acc.saleQty > 0 ? round2(acc.saleAmount / acc.saleQty) : 0,
      avgPurchaseRate:
        acc.saleQty > 0 ? round2(acc.purchaseAmount / acc.saleQty) : 0,
      saleAmount: round2(acc.saleAmount),
      purchaseAmount: round2(acc.purchaseAmount),
      profit: round2(acc.profit),
      profitPercent:
        acc.purchaseAmount > 0
          ? round2((acc.profit / acc.purchaseAmount) * 100)
          : 0,
    };
  }, [rows]);

  const bandCounts = useMemo(() => {
    const acc = {
      green: 0,
      orange: 0,
      blue: 0,
      red: 0,
    };

    searchedAndFilteredRows.forEach((r) => {
      if (acc[r?.profitBand] !== undefined) acc[r.profitBand] += 1;
    });

    return acc;
  }, [searchedAndFilteredRows]);

  const openModal = () => {
    addBufferRef.current = [];
    setSelectedIndex(-1);
    setModal(true);
  };

  const closeModal = () => setModal(false);

  const handleCheckbox = (checked, colKey) => {
    const buf = addBufferRef.current.slice();

    if (checked) {
      if (!buf.includes(colKey)) buf.push(colKey);
    } else {
      const i = buf.indexOf(colKey);
      if (i >= 0) buf.splice(i, 1);
    }

    addBufferRef.current = buf;
  };

  const addSelectedColumns = () => {
    const next = Array.from(
      new Set([...selectedKeys, ...addBufferRef.current]),
    );
    setSelectedKeys(next);
  };

  const addAllColumns = () => {
    setSelectedKeys(BASE_COLS.map((c) => c.key));
    setSelectedIndex(-1);
  };

  const showProfitColumns = () => {
    setSelectedKeys([
      "product",
      "saleAmount",
      "purchaseAmount",
      "profit",
      "profitPercent",
      "profitBand",
    ]);
    setSelectedIndex(-1);
  };

  const showRateColumns = () => {
    setSelectedKeys([
      "product",
      "saleQty",
      "avgSaleRate",
      "avgPurchaseRate",
      "profitPercent",
    ]);
    setSelectedIndex(-1);
  };

  const removeAtIndex = () => {
    if (selectedIndex < 0) return;
    if (selectedKeys.length <= 1) return;

    const next = selectedKeys.slice();
    next.splice(selectedIndex, 1);
    setSelectedKeys(next);
    setSelectedIndex(-1);
  };

  const shiftUp = () => {
    if (selectedIndex <= 0) return;

    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex - 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex - 1);
  };

  const shiftDown = () => {
    if (selectedIndex < 0 || selectedIndex >= selectedKeys.length - 1) return;

    const next = selectedKeys.slice();
    const el = next.splice(selectedIndex, 1)[0];
    next.splice(selectedIndex + 1, 0, el);
    setSelectedKeys(next);
    setSelectedIndex(selectedIndex + 1);
  };

  const applyColumns = (e) => {
    e.preventDefault();

    const finalKeys = selectedKeys.length
      ? selectedKeys
      : BASE_COLS.map((c) => c.key);

    const toPersist = finalKeys.map((k) => ({
      key: k,
      header: colMap.get(k)?.header || k,
    }));

    localStorage.setItem("ProfitWiseReportCols", JSON.stringify(toPersist));
    setSelectedKeys(finalKeys);
    closeModal();
  };

  const resetFilters = () => {
    setFilterType("yearly");
    setPeriodValue("");
    setProfitColorFilter("all");
    setQuickFilter("all");
    setLimitMode("all");
    setSearchTerm("");

    if (fyOptions?.length) {
      setSelectedFY(fyOptions[0].value);
    } else {
      setSelectedFY("");
    }
  };

  const toFlatRow = (r) => ({
    "Product Name": r?.productName || "",
    "Sale Quantity": round2(r?.saleQty ?? 0).toFixed(2),
    "Average Sale Rate": round2(r?.avgSaleRate ?? 0).toFixed(2),
    "Average Purchase Rate": round2(r?.avgPurchaseRate ?? 0).toFixed(2),
    "Sale Amount": round2(r?.saleAmount ?? 0).toFixed(2),
    "Purchase Amount": round2(r?.purchaseAmount ?? 0).toFixed(2),
    Profit: round2(r?.profit ?? 0).toFixed(2),
    "Profit %": `${round2(r?.profitPercent ?? 0).toFixed(2)}%`,
    Band: getProfitBandLabel(r?.profitBand),
  });

  const exportXLSX = (fileName = "ProfitWiseReport") => {
    const data = rows.map(toFlatRow);
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const buf = XLSX.write(wb, { bookType: "xlsx", type: "array" });

    saveAs(
      new Blob([buf], { type: "application/octet-stream" }),
      `${fileName}.xlsx`,
    );
  };

  const exportCSVForPDF = () => {
    const header = visibleCols.map((c) => c.header).join(",");

    const lines = rows.map((r) =>
      visibleCols
        .map((c) => {
          const v = toStr(c.get(r)).replace(/"/g, '""');
          return `"${v}"`;
        })
        .join(","),
    );

    return [header, ...lines].join("\r\n");
  };

  const exportPDF = async () => {
    const csv = exportCSVForPDF();
    await exportDataToPDF(csv, "ProfitWiseReport");
  };

  const handleSort = (key) => {
    setLimitMode("all");

    setSortConfig((prev) => {
      if (prev.key !== key) return { key, dir: "asc" };
      return { key, dir: prev.dir === "asc" ? "desc" : "asc" };
    });
  };

  const sortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort size={10} />;
    return sortConfig.dir === "asc" ? (
      <FaSortUp size={11} />
    ) : (
      <FaSortDown size={11} />
    );
  };

  if (loading) {
    return (
      <div className="pwr-page">
        <div className="pwr-loader">
          <Spinner color="primary">Loading...</Spinner>
          <div>Loading Profit Wise Report...</div>
        </div>
      </div>
    );
  }

  const noData = !rows?.length;
  const rowPaddingClass = density === "comfortable" ? "comfortable" : "compact";

  return (
    <div className={`pwr-page ${rowPaddingClass}`}>
      {errorMsg && (
        <Row>
          <Col sm="12">
            <Alert color="danger" style={{ marginBottom: 8 }}>
              {errorMsg}
            </Alert>
          </Col>
        </Row>
      )}

      <div className="pwr-top-shell">
        <div className="pwr-command-row">
          <div className="pwr-brand">
            <FaChartLine />
            Profit Wise Report
            <span className="pwr-count">{rows.length}</span>
          </div>

          <div className="pwr-smart-card">
            <b>Sale</b>
            <span>{money(totals.saleAmount)}</span>
          </div>

          <div className="pwr-smart-card">
            <b>Purchase</b>
            <span>{money(totals.purchaseAmount)}</span>
          </div>

          <div className="pwr-smart-card">
            <b>Profit</b>
            <span
              className={Number(totals.profit || 0) < 0 ? "pwr-neg" : "pwr-pos"}
            >
              {money(totals.profit)}
            </span>
          </div>

          <div className="pwr-smart-card">
            <b>Margin</b>
            <span
              style={{
                color: getProfitColor(totals.profitPercent, colorConfig),
              }}
            >
              {money(totals.profitPercent)}%
            </span>
          </div>

          <div className="pwr-searchbox">
            <FaSearch size={12} />
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Smart search product / value / band..."
            />
            {searchTerm ? (
              <FaTimes
                size={11}
                style={{ cursor: "pointer" }}
                onClick={() => setSearchTerm("")}
              />
            ) : null}
          </div>

          <div className="pwr-field">
            <Label>FY</Label>
            <Input
              className="pwr-select-fy"
              type="select"
              value={selectedFY}
              onChange={(e) => setSelectedFY(e.target.value)}
            >
              <option value="">All</option>
              {fyOptions.map((fy) => (
                <option key={fy.value} value={fy.value}>
                  {fy.label}
                </option>
              ))}
            </Input>
          </div>

          <div className="pwr-field">
            <Label>Type</Label>
            <Input
              className="pwr-select-type"
              type="select"
              value={filterType}
              onChange={(e) => setFilterType(e.target.value)}
            >
              <option value="yearly">Yearly</option>
              <option value="halfYearly">Half</option>
              <option value="quarterly">Quarter</option>
              <option value="monthly">Monthly</option>
            </Input>
          </div>

          <div className="pwr-field">
            <Label>Period</Label>
            <Input
              className="pwr-select-period"
              type="select"
              value={periodValue}
              onChange={(e) => setPeriodValue(e.target.value)}
              disabled={filterType === "yearly"}
            >
              {filterType === "yearly" && <option value="">Full</option>}

              {filterType === "halfYearly" && (
                <>
                  <option value="H1">H1 Apr-Sep</option>
                  <option value="H2">H2 Oct-Mar</option>
                </>
              )}

              {filterType === "quarterly" && (
                <>
                  <option value="Q1">Q1 Apr-Jun</option>
                  <option value="Q2">Q2 Jul-Sep</option>
                  <option value="Q3">Q3 Oct-Dec</option>
                  <option value="Q4">Q4 Jan-Mar</option>
                </>
              )}

              {filterType === "monthly" &&
                monthOptionsFY.map((m) => (
                  <option key={m} value={m}>
                    {m}
                  </option>
                ))}
            </Input>
          </div>

          <div className="pwr-field">
            <Label>Band</Label>
            <Input
              className="pwr-select-band"
              type="select"
              value={profitColorFilter}
              onChange={(e) => setProfitColorFilter(e.target.value)}
            >
              <option value="all">All</option>
              <option value="green">Green ≥15</option>
              <option value="orange">Orange 10</option>
              <option value="blue">Blue 5</option>
              <option value="red">Red 0</option>
            </Input>
          </div>

          <div className="pwr-field">
            <Label>Smart</Label>
            <Input
              className="pwr-select-limit"
              type="select"
              value={limitMode}
              onChange={(e) => setLimitMode(e.target.value)}
            >
              <option value="all">All Rows</option>
              <option value="top10">Top Profit</option>
              <option value="bottom10">Lowest Profit</option>
              <option value="topMargin">Top Margin</option>
              <option value="topSale">Top Sale</option>
            </Input>
          </div>

          <Button
            size="sm"
            color="primary"
            className="pwr-icon-btn pwr-primary-btn"
            onClick={() => setAdvancedOpen((p) => !p)}
            title="Quick Filters"
          >
            <FaSlidersH size={12} />
            Filter
          </Button>

          <Button
            size="sm"
            outline
            color="secondary"
            className="pwr-icon-btn"
            onClick={resetFilters}
            title="Reset"
          >
            Reset
          </Button>

          <Button
            size="sm"
            outline
            color="primary"
            className="pwr-icon-btn"
            onClick={openModal}
            title="Dynamic Columns"
          >
            <FaColumns size={13} />
            Col
          </Button>

          <Button
            size="sm"
            outline
            color="primary"
            className="pwr-icon-btn"
            onClick={loadData}
            title="Refresh"
          >
            <FaSyncAlt size={12} />
          </Button>

          <Button
            size="sm"
            outline
            color="dark"
            className="pwr-icon-btn"
            onClick={() =>
              setViewMode(viewMode === "table" ? "cards" : "table")
            }
            title="Toggle Table / Cards"
          >
            {viewMode === "table" ? (
              <FaLayerGroup size={12} />
            ) : (
              <FaEye size={12} />
            )}
          </Button>

          <Button
            size="sm"
            outline
            color="dark"
            className="pwr-icon-btn"
            onClick={() =>
              setDensity(density === "compact" ? "comfortable" : "compact")
            }
            title="Toggle Density"
          >
            {density === "compact" ? (
              <FaExpandAlt size={12} />
            ) : (
              <FaCompressAlt size={12} />
            )}
          </Button>

          {permissions?.Download && (
            <div
              className="pwr-download-wrap"
              onMouseEnter={() => setDownloadOpen(true)}
              onMouseLeave={() => setDownloadOpen(false)}
            >
              <div className="pwr-download-trigger" title="Download">
                <ImDownload size={18} />
              </div>

              {downloadOpen && (
                <div className="pwr-download-menu">
                  <div onClick={exportPDF} className="pwr-dl-item">
                    <FaFilePdf />
                    PDF
                  </div>

                  <div
                    onClick={() => exportXLSX("ProfitWiseReport")}
                    className="pwr-dl-item"
                  >
                    <FaFileExcel />
                    Excel
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {advancedOpen && (
          <div className="pwr-advanced">
            <div className="pwr-chip-line">
              <button
                type="button"
                className={`pwr-chip ${quickFilter === "all" ? "active" : ""}`}
                onClick={() => setQuickFilter("all")}
              >
                <FaMagic /> All
              </button>

              <button
                type="button"
                className={`pwr-chip ${
                  quickFilter === "profit" ? "active" : ""
                }`}
                onClick={() => setQuickFilter("profit")}
              >
                Profitable
              </button>

              <button
                type="button"
                className={`pwr-chip ${quickFilter === "loss" ? "active" : ""}`}
                onClick={() => setQuickFilter("loss")}
              >
                Loss
              </button>

              <button
                type="button"
                className={`pwr-chip ${quickFilter === "high" ? "active" : ""}`}
                onClick={() => setQuickFilter("high")}
              >
                High Margin
              </button>

              <button
                type="button"
                className={`pwr-chip ${quickFilter === "risk" ? "active" : ""}`}
                onClick={() => setQuickFilter("risk")}
              >
                Risk Margin
              </button>

              <button
                type="button"
                className={`pwr-chip ${
                  quickFilter === "zeroPurchase" ? "active" : ""
                }`}
                onClick={() => setQuickFilter("zeroPurchase")}
              >
                Zero Purchase
              </button>

              <span className="pwr-chip">
                <span
                  className="pwr-dot"
                  style={{ background: colorConfig.green }}
                />
                Green {bandCounts.green}
              </span>

              <span className="pwr-chip">
                <span
                  className="pwr-dot"
                  style={{ background: colorConfig.orange }}
                />
                Orange {bandCounts.orange}
              </span>

              <span className="pwr-chip">
                <span
                  className="pwr-dot"
                  style={{ background: colorConfig.blue }}
                />
                Blue {bandCounts.blue}
              </span>

              <span className="pwr-chip">
                <span
                  className="pwr-dot"
                  style={{ background: colorConfig.red }}
                />
                Red {bandCounts.red}
              </span>
            </div>
          </div>
        )}
      </div>

      {masterShow && (
        <div className="pwr-master-box">
          <SuperAdminUI
            onDropdownChange={(v) =>
              localStorage.setItem("SuperadminIdByMaster", JSON.stringify(v))
            }
            onSubmit={(e) => e.preventDefault()}
          />
        </div>
      )}

      <div className="pwr-table-card">
        <div className="pwr-table-head">
          <div className="pwr-table-title">
            <FaFilter />
            Product Profit Details
          </div>

          <div className="pwr-table-meta">
            Showing {rows.length} product(s) / {filteredItems.length} sale
            item(s)
          </div>
        </div>

        {noData ? (
          <div className="pwr-empty">
            <div className="pwr-empty-title">No records found</div>
            <div>
              Try changing search, FY, period, profit band or smart filter.
            </div>
          </div>
        ) : viewMode === "cards" ? (
          <div className="pwr-card-grid">
            {rows.map((r, i) => (
              <div key={r?.productId || i} className="pwr-product-card">
                <div
                  className="pwr-card-title"
                  style={{
                    color: getProfitColor(r?.profitPercent, colorConfig),
                  }}
                >
                  {r?.productName}
                </div>

                <div className="pwr-card-row">
                  <b>Sale Qty</b>
                  <span>{money(r?.saleQty)}</span>
                </div>

                <div className="pwr-card-row">
                  <b>Sale Amount</b>
                  <span>{money(r?.saleAmount)}</span>
                </div>

                <div className="pwr-card-row">
                  <b>Purchase</b>
                  <span>{money(r?.purchaseAmount)}</span>
                </div>

                <div className="pwr-card-row">
                  <b>Profit</b>
                  <span className={N(r?.profit) < 0 ? "pwr-neg" : "pwr-pos"}>
                    {money(r?.profit)}
                  </span>
                </div>

                <div className="pwr-card-row">
                  <b>Margin</b>
                  <span
                    style={{
                      color: getProfitColor(r?.profitPercent, colorConfig),
                    }}
                  >
                    {money(r?.profitPercent)}%
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="pwr-table-wrap">
            <table className="pwr-table">
              <thead>
                <tr>
                  {visibleCols.map((c, idx) => (
                    <th
                      key={c.key}
                      className={idx === 0 ? "pwr-first-col" : ""}
                      onClick={() => handleSort(c.key)}
                      title="Click to sort"
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 5,
                        }}
                      >
                        {c.header}
                        {sortIcon(c.key)}
                      </span>
                    </th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {rows.map((r, i) => (
                  <tr key={r?.productId || i}>
                    {visibleCols.map((c, idx) => (
                      <td
                        key={c.key}
                        className={idx === 0 ? "pwr-first-col" : ""}
                      >
                        {typeof c.render === "function"
                          ? c.render(r, colorConfig)
                          : toStr(c.get(r))}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>

              <tfoot>
                <tr>
                  {visibleCols.map((c, idx) => {
                    switch (c.key) {
                      case "saleQty":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {totals.saleQty.toFixed(2)}
                          </td>
                        );

                      case "avgSaleRate":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {totals.avgSaleRate.toFixed(2)}
                          </td>
                        );

                      case "avgPurchaseRate":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {totals.avgPurchaseRate.toFixed(2)}
                          </td>
                        );

                      case "saleAmount":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {totals.saleAmount.toFixed(2)}
                          </td>
                        );

                      case "purchaseAmount":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {totals.purchaseAmount.toFixed(2)}
                          </td>
                        );

                      case "profit":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            <span
                              className={
                                Number(totals.profit || 0) < 0
                                  ? "pwr-neg"
                                  : "pwr-pos"
                              }
                            >
                              {totals.profit.toFixed(2)}
                            </span>
                          </td>
                        );

                      case "profitPercent":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            <span
                              style={{
                                color: getProfitColor(
                                  totals.profitPercent,
                                  colorConfig,
                                ),
                              }}
                            >
                              {totals.profitPercent.toFixed(2)}%
                            </span>
                          </td>
                        );

                      case "profitBand":
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            -
                          </td>
                        );

                      default:
                        return (
                          <td
                            key={c.key}
                            className={idx === 0 ? "pwr-first-col" : ""}
                          >
                            {c.key === visibleCols[0]?.key ? "Total" : ""}
                          </td>
                        );
                    }
                  })}
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>

      <Modal
        isOpen={modal}
        toggle={closeModal}
        zIndex={2000}
        backdrop="static"
        keyboard={false}
        style={{ maxWidth: 1080 }}
      >
        <ModalHeader toggle={closeModal}>Dynamic Column Manager</ModalHeader>

        <ModalBody>
          <Row>
            <Col lg="4" md="4" sm="12" xl="4" xs="12">
              <div className="pwr-modal-title">
                <FaColumns />
                Available Columns
              </div>

              <div className="picklist">
                {BASE_COLS.map((col) => (
                  <div key={col.key} className="pickitem">
                    <label
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 0,
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        defaultChecked={selectedKeys.includes(col.key)}
                        onChange={(e) =>
                          handleCheckbox(e.target.checked, col.key)
                        }
                      />
                      <span>{col.header}</span>
                    </label>

                    {selectedKeys.includes(col.key) ? (
                      <FaEye size={13} color="#16a34a" />
                    ) : (
                      <FaEyeSlash size={13} color="#94a3b8" />
                    )}
                  </div>
                ))}
              </div>

              <div className="pwr-modal-actions">
                <Button size="sm" color="primary" onClick={addSelectedColumns}>
                  Add Selected →
                </Button>

                <Button
                  size="sm"
                  outline
                  color="secondary"
                  onClick={addAllColumns}
                >
                  Show All
                </Button>
              </div>

              <div className="pwr-modal-actions">
                <Button
                  size="sm"
                  outline
                  color="success"
                  onClick={showProfitColumns}
                >
                  Profit View
                </Button>

                <Button
                  size="sm"
                  outline
                  color="info"
                  onClick={showRateColumns}
                >
                  Rate View
                </Button>
              </div>
            </Col>

            <Col lg="8" md="8" sm="12" xl="8" xs="12">
              <div className="pwr-modal-title">
                <FaPalette />
                Visible Columns
              </div>

              <div
                style={{
                  display: "flex",
                  gap: 12,
                  alignItems: "flex-start",
                }}
              >
                <div className="picklist" style={{ flex: 1 }}>
                  {selectedKeys.map((key, i) => {
                    const col = colMap.get(key);
                    if (!col) return null;

                    return (
                      <div
                        key={`${key}-${i}`}
                        className="pickitem"
                        style={{
                          background: i === selectedIndex ? "#1d4ed8" : "#fff",
                          color: i === selectedIndex ? "#fff" : "#0f172a",
                          borderColor:
                            i === selectedIndex ? "#1d4ed8" : "#e5e7eb",
                        }}
                        onClick={() => setSelectedIndex(i)}
                      >
                        <span>{col.header}</span>
                        <span style={{ fontSize: 11, opacity: 0.8 }}>
                          {col.type}
                        </span>
                      </div>
                    );
                  })}
                </div>

                <div style={{ display: "grid", gap: 8 }}>
                  <Button size="sm" onClick={shiftUp}>
                    ↑
                  </Button>

                  <Button size="sm" onClick={shiftDown}>
                    ↓
                  </Button>

                  <Button size="sm" color="danger" onClick={removeAtIndex}>
                    Remove
                  </Button>
                </div>
              </div>

              <div className="pwr-modal-actions">
                <Button color="primary" onClick={applyColumns}>
                  Submit
                </Button>

                <Button outline color="secondary" onClick={closeModal}>
                  Cancel
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    </div>
  );
}
